import { convertColumnNameToPascalCase } from "../ItemPageShared/ItemUtils";
import '../itemPage.css';
const DropdownInput = ({
    rowIndex,
    column,
    activeCell,
    // handleScroll,
    value,
    placeholder,
    inputRefs,
    handleChange,
    handleKeyDown,
    handlePaste,
    searchResults,
    highlightedIndex, setActiveCell,
    isDropdownOpen,
    loading,
    dropdownRef,
    handleItemSelect
}) => (

    
    
    <>
    
    <div className="dropdown-container h-100">
        <input
            className={`input-field `}
            type="text"
            value={value}
            placeholder={placeholder}
            onFocus={() => setActiveCell({ rowIndex, column })}
            onChange={(e) => handleChange(e, rowIndex, column)}
            onKeyDown={(e) => handleKeyDown(e, rowIndex, column)}
            ref={(el) => { inputRefs.current[`${rowIndex}-${column}`] = el; }}
            onPaste={(e) => handlePaste(e, rowIndex,column)}
        />
     
        
        {isDropdownOpen && value  && activeCell.rowIndex === rowIndex && activeCell.column === column && (
            <div className="dropdown-list" ref={dropdownRef}
            // onScroll={handleScroll}
            >
                {loading.GetItmBySearch && <div className="loading-indicator">Loading...</div>}
                {!loading.GetItmBySearch && searchResults.length === 0 && (
                    <div className="no-items">No items found</div>
                )}
                {searchResults.map((item, idx) => {
                    const pascalItem = Object.keys(item).reduce((acc, key) => {
                        acc[convertColumnNameToPascalCase(key)] = item[key];
                        return acc;
                    }, {});
                    return (
                        <div
                            key={idx}
                            className={`dropdown-item ${idx === highlightedIndex ? "highlighted" : ""}`}
                            onClick={() => handleItemSelect(item, rowIndex, column)}
                        >
                            {pascalItem["Item Code"]} - {pascalItem["Item Name"]}
                        </div>
                    );
                })}
            </div>
        )}
            </div>
   </>
);


export default DropdownInput;
